import React from "react";
import { ReactComponent as CalibrateIcon } from "../../assets/icons/calibrate.svg";
import { ReactComponent as CircleIcon } from "../../assets/icons/circle_empty.svg";
import { ReactComponent as SquareIcon } from "../../assets/icons/square.svg";
import { ReactComponent as GestureIcon } from "../../assets/icons/gesture.svg";
import { ReactComponent as ZoomInIcon } from "../../assets/icons/zoom_in.svg";
import { ReactComponent as ZoomOutIcon } from "../../assets/icons/zoom_out.svg";
import { ReactComponent as CoursorIcon } from "../../assets/icons/cursor.svg";
import { ReactComponent as FormatIcon } from "../../assets/icons/format.svg";
import { ReactComponent as CropFreeIcon } from "../../assets/icons/crop_free.svg";
import { ReactComponent as PhotoIcon } from "../../assets/icons/photo.svg";
import { ReactComponent as UndoIcon } from "../../assets/icons/undo.svg";
import { ReactComponent as BackIcon } from "../../assets/icons/arrow-back.svg";
import { ReactComponent as ForwardIcon } from "../../assets/icons/arrow-forward.svg";


const tools = [
  {
    name: "select",
    icon: <CoursorIcon />,
    label: "Select",
  },
  {
    name: "polygon",
    icon: <GestureIcon />,
    label: "Polygon",
  },
  {
    name: "rectangle",
    icon: <SquareIcon />,
    label: "Rectangle",
  },
  {
    name: "circle",
    icon: <CircleIcon />,
    label: "Circle",
  },
  {
    name: "zoomin",
    icon: <ZoomInIcon />,
    label: "Zoom",
  },
  {
    name: "zoomout",
    icon: <ZoomOutIcon />,
    label: "Zoom",
  },
  {
    name: "undo",
    icon: <UndoIcon />,
    label: "Undo",
  },
  {
    name: "format",
    icon: <FormatIcon />,
    label: "Text",
  },
  {
    name: "crop",
    icon: <CropFreeIcon />,
    label: "Crop",
  }
]

export default tools;